import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import ArgonDashboard from "./argon-dashboard";
import VueTableLite from "vue3-table-lite";
//import {ServerTable, ClientTable} from 'v-tables-3';
//import SmartTable from 'vuejs-smart-table'
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';


const appInstance = createApp(App);
//appInstance.use(SmartTable)
appInstance.use(store);
appInstance.use(VueSweetalert2);
appInstance.use(router);
appInstance.use(ArgonDashboard);
appInstance.use(VueTableLite)
appInstance.component('VueDatePicker', VueDatePicker);
//appInstance.use(ServerTable)
appInstance.mount("#app");
//store.state.darkMode=true;